var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_264_47",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_264_47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0254 20.55L13.2504 14.8C12.7504 15.2167 12.1754 15.5417 11.5254 15.775C10.8754 16.0083 10.2087 16.125 9.52539 16.125C7.80872 16.125 6.35872 15.5333 5.17539 14.35C3.99206 13.1667 3.40039 11.7167 3.40039 10C3.40039 8.3 3.99206 6.854 5.17539 5.662C6.35872 4.47067 7.80872 3.875 9.52539 3.875C11.2254 3.875 12.6671 4.46667 13.8504 5.65C15.0337 6.83333 15.6254 8.28333 15.6254 10C15.6254 10.7167 15.5087 11.4 15.2754 12.05C15.0421 12.7 14.7254 13.2667 14.3254 13.75L20.1004 19.525C20.2337 19.6583 20.3004 19.825 20.3004 20.025C20.3004 20.225 20.2254 20.4 20.0754 20.55C19.9254 20.7 19.7464 20.775 19.5384 20.775C19.3297 20.775 19.1587 20.7 19.0254 20.55ZM9.52539 14.625C10.8087 14.625 11.8964 14.175 12.7884 13.275C13.6797 12.375 14.1254 11.2833 14.1254 10C14.1254 8.71667 13.6797 7.625 12.7884 6.725C11.8964 5.825 10.8087 5.375 9.52539 5.375C8.22539 5.375 7.12972 5.825 6.23839 6.725C5.34639 7.625 4.90039 8.71667 4.90039 10C4.90039 11.2833 5.34639 12.375 6.23839 13.275C7.12972 14.175 8.22539 14.625 9.52539 14.625Z",
    fill: "#CBCBCB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c919ac3659d20650bd766d792d25a777.svg";
export { ForwardRef as ReactComponent };